// extracted by mini-css-extract-plugin
module.exports = {"editorialFeatureCard":"EditorialFeatureCard_editorialFeatureCard__eTr_6"};